// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoModal_container__17nWC","info":"InfoModal_info__nZb2o","text":"InfoModal_text__2P2Iz","actions":"InfoModal_actions__CEl0x"};